"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWrapper = exports.Container = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.Container = (0, flora_react_1.styled)(flora_react_1.Box, {
    alignItems: 'center',
    display: 'flex',
    height: '48px',
    justifyContent: 'space-between',
    padding: '$4 0',
    width: '100%',
});
exports.IconWrapper = (0, flora_react_1.styled)(flora_react_1.Box, {
    paddingRight: '$1',
    svg: {
        color: '$backgroundAltTertiary',
        path: {
            fill: '$backgroundAltTertiary',
        },
    },
});
